import { iUIState, tDiscountPercent } from "../../interfaces"
import { discountPercents } from "../../settings";
import { eUIActionTypes, tUIAction } from "./UITypes"

const initialState: iUIState = {
	isDepositAvailable: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: false}), {}) as {[key in tDiscountPercent]: boolean},
}

export const UIReducer = (state = initialState, action: tUIAction): iUIState => {
	switch(action.type){
		
		case eUIActionTypes.CLEAR_STATE:
			return initialState
		;

		case eUIActionTypes.SET_IS_DEPOSIT_AVAILABLE:
			if (action.payload.state === state.isDepositAvailable[action.payload.percent]) return state;
			return {
				...state,
				isDepositAvailable: Object.assign(
					{},
					state.isDepositAvailable,
					{[action.payload.percent]: action.payload.state}
				)
			}
		;

		default: return state;
	}
}